"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_DATALAKE_AUTH_SCOPES = exports.ALL_LEGACY_AUTH_SCOPES = exports.ALL_BORROWING_BASE_SCOPES = exports.ALL_BORROWING_BASE_PIPELINE_SCOPES = exports.ALL_BANK_ACCOUNT_SCOPES = exports.ALL_CALC_VERIFICATION_SCOPES = exports.ALL_FUNDING_REQUEST_SCOPES = exports.DirectInsertClassDetailsSchema = exports.ClassLabel = exports.ClassLabelIterable = exports.CreditFacilityStructureType = exports.CreditFacilityStructureTypeIterable = void 0;
const zod_1 = require("zod");
const DataLake_1 = require("./DataLake");
exports.CreditFacilityStructureTypeIterable = [
    'fixedProportion',
    'classed',
];
exports.CreditFacilityStructureType = {
    FixedProportion: 'fixedProportion',
    Classed: 'classed',
};
//  ChatGPT replacement option for ClassLabel type using template literal types:
// type ClassLabelLetters = 'A' | ... | 'F';
//  type ClassLabelNumbers = '' | '1' | '2';
// type ClassLabel = `${ClassLabelLetters}${ClassLabelNumbers}`;
// Class labels can follow a sequence like: A, B, C1, C2, D
exports.ClassLabelIterable = [
    'a',
    'a1',
    'a2',
    'b',
    'b1',
    'b2',
    'c',
    'c1',
    'c2',
    'd',
    'd1',
    'd2',
    'e',
    'e1',
    'e2',
    'f',
    'f1',
    'f2',
];
exports.ClassLabel = {
    A: 'a',
    A1: 'a1',
    A2: 'a2',
    B: 'b',
    B1: 'b1',
    B2: 'b2',
    C: 'c',
    C1: 'c1',
    C2: 'c2',
    D: 'd',
    D1: 'd1',
    D2: 'd2',
    E: 'e',
    E1: 'e1',
    E2: 'e2',
    F: 'f',
    F1: 'f1',
    F2: 'f2',
};
// ============================================================================
// DIRECT INSERT CLASS DETAILS SCHEMA
// ============================================================================
// associated with DirectInsertBorrowingBase, but cannot live that file due to circ dep
exports.DirectInsertClassDetailsSchema = zod_1.z.object({
    a: zod_1.z.number().optional(),
    a1: zod_1.z.number().optional(),
    a2: zod_1.z.number().optional(),
    b: zod_1.z.number().optional(),
    b1: zod_1.z.number().optional(),
    b2: zod_1.z.number().optional(),
    c: zod_1.z.number().optional(),
    c1: zod_1.z.number().optional(),
    c2: zod_1.z.number().optional(),
    d: zod_1.z.number().optional(),
    d1: zod_1.z.number().optional(),
    d2: zod_1.z.number().optional(),
    e: zod_1.z.number().optional(),
    e1: zod_1.z.number().optional(),
    e2: zod_1.z.number().optional(),
    f: zod_1.z.number().optional(),
    f1: zod_1.z.number().optional(),
    f2: zod_1.z.number().optional(),
});
exports.ALL_FUNDING_REQUEST_SCOPES = [
    /** Start a new funding request pipeline run. */
    'fundingRequestPipeline:initiate',
    /**
     * View progress of an existing funding request pipeline run.
     *
     * Implies:
     * - list all historical pipeline runs
     * - view errors encountered during the run
     * - view the inputs used to initiate the run
     */
    'fundingRequestPipeline.progress:view',
    /** View the results of a funding request pipeline run. */
    'fundingRequestPipeline.outputs:view',
];
exports.ALL_CALC_VERIFICATION_SCOPES = [
    /** Start a new calc verification run. */
    'calcVerification:initiate',
    /**
     * View progress of an existing calc verification run.
     *
     * Implies:
     * - list all historical pipeline runs
     * - view errors encountered during the run
     * - view the inputs used to initiate the run
     */
    'calcVerification.progress:view',
    /** View the results of a calc verification run. */
    'calcVerification.outputs:view',
    /** Initiate a verification remediation request on an existing verification report */
    'calcVerification.remediation:initiate',
    /** Upload receivable documentation */
    'calcVerification:uploadReceivableDocumentation',
    /** View receivable documentation */
    'calcVerification.receivableDocumentation:view',
];
exports.ALL_BANK_ACCOUNT_SCOPES = [
    /** View bank account data. */
    'bankAccount:view',
];
/**
 * The borrowing base pipeline scopes below are very broad and is in practice not very secure in their current implementation
 * Longer term, we will want to have workflow-based authz on the bbpl, where we are authorizing based on the intended action on the artifactDocument, artifact, or artifactInstance based on the context of its caller's intention.
 */
exports.ALL_BORROWING_BASE_PIPELINE_SCOPES = [
    /** View bbpl artifact document. */
    'borrowingBasePipeline.artifactDocument:view',
    /** View bbpl artifact. */
    'borrowingBasePipeline.artifact:view',
    /** View bbpl artifact instance. */
    'borrowingBasePipeline.artifactInstance:view',
];
/**
 * The borrowing base pipeline scopes below are very broad and is in practice not very secure in their current implementation
 * Longer term, we will want to have workflow-based authz on the bbpl, where we are authorizing based on the intended action on the artifactDocument, artifact, or artifactInstance based on the context of its caller's intention.
 */
exports.ALL_BORROWING_BASE_SCOPES = [
    /** View receivable borrowing base test waivers. */
    'borrowingBase.receivableBorrowingBaseTestWaivers:view',
    /** Update receivable borrowing base test waivers. */
    'borrowingBase.receivableBorrowingBaseTestWaivers:update',
];
// These coarse-grained permissions were introduced to facilitate migration away from legacy auth
// checks that only cared about party type. Going forward we should try to use finer-grained access
// controls.
exports.ALL_LEGACY_AUTH_SCOPES = [
    'legacyScope:isBorrower',
    'legacyScope:isCapitalProvider',
    'legacyScope:isBorrowerOrCapitalProvider',
    'legacyScope:isAdmin',
];
exports.ALL_DATALAKE_AUTH_SCOPES = DataLake_1.ALL_TABLE_PREFIXES.map((tablePrefix) => `datalake.${tablePrefix}:read`);
//# sourceMappingURL=CreditFacility.js.map